/**
 * Fond de carte : `VITE_MAP_STYLE` peut pointer vers un style MapLibre (tileserver auto-hébergé, MapTiler…).
 * Vide ou « osm » : tuiles raster OpenStreetMap (rues, villes, relief), sans serveur à installer.
 * Le tileserver local de docker-compose ne contient que l'échantillon de Zurich : inutilisable en Guinée.
 * En production à fort trafic, préférer un fournisseur de tuiles (politique d'usage des tuiles OSM).
 */
export const OSM_RASTER_STYLE = {
  version: 8 as const,
  sources: {
    osm: {
      type: 'raster' as const,
      tiles: ['https://tile.openstreetmap.org/{z}/{x}/{y}.png'],
      tileSize: 256,
      maxzoom: 19,
      attribution: '© contributeurs OpenStreetMap',
    },
  },
  layers: [{ id: 'osm', type: 'raster' as const, source: 'osm' }],
};

export const resolveMapStyle = (envValue: string | undefined): string | typeof OSM_RASTER_STYLE =>
  !envValue || envValue === 'osm' ? OSM_RASTER_STYLE : envValue;
